import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import MoreInfoNotificationModal from './MoreInfoNotificationModal';
import { useLoggedInUserContext } from '../../../context/LoggedInUserContextProvider';
import { desktopMediaQuery } from '../../../styleHelpers';

const text =
  'SuperV1 is currently offline due to low usage while costing us 4x more. We\'ll bring it back when we figure out a more sustainable approach 🙏';

const SHOW_MORE_INFO_BUTTON = false;
const AUTO_HIDE_NOTIFICATION_AFTER_DATE = new Date('2025-05-18');

const NotificationBar = () => {
  const { loggedInUser } = useLoggedInUserContext();
  const location = useLocation();
  const [showNotification, setShowNotification] = useState(false);
  const [showMoreInfoModal, setShowMoreInfoModal] = useState(false);

  const NO_NOTIFICATION = false;

  useEffect(() => {
    if (NO_NOTIFICATION || location.pathname.includes('/chat')) {
      setShowNotification(false);
      return;
    }
    if (new Date() > AUTO_HIDE_NOTIFICATION_AFTER_DATE) {
      setShowNotification(false);
      return;
    }

    if (!loggedInUser) {
      setShowNotification(false);
      return;
    }

    const nameOfItem = 'notificationSuperV1Offline05092025';
    const notificationSeenCount = Number(
      localStorage.getItem(nameOfItem) || '0',
    );

    if (notificationSeenCount >= 1) {
      setShowNotification(false);
      return;
    }

    localStorage.setItem(nameOfItem, String(notificationSeenCount + 1));
    setShowNotification(true);
  }, [loggedInUser, location.pathname]);

  const handleClose = () => {
    setShowNotification(false);
  };

  const handleMoreInfo = () => {
    setShowMoreInfoModal(true);
  };

  if (!showNotification) return null;

  return (
    <>
      <NotificationBarContainer>
        <NotificationText>{text}</NotificationText>
        <ButtonContainer>
          {SHOW_MORE_INFO_BUTTON && (
            <MoreInfoButton onClick={handleMoreInfo}>More Info</MoreInfoButton>
          )}
          <CloseButton onClick={handleClose}>X</CloseButton>
        </ButtonContainer>
      </NotificationBarContainer>
      <MoreInfoNotificationModal
        show={showMoreInfoModal}
        setShow={setShowMoreInfoModal}
      />
    </>
  );
};

const NotificationBarContainer = styled.div`
  margin-left: 1%;
  width: 92%;
  background-color: #d0e7ff;
  border-radius: 4px;
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  position: relative;

  ${desktopMediaQuery} {
    max-width: 65vw;
    margin-left: 10vw;
  }
`;

const NotificationText = styled.div`
  flex: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const MoreInfoButton = styled.button`
  color: black;
  background: none;
  border: 1px solid black;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
`;

const CloseButton = styled.button`
  color: black;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
`;

export default NotificationBar;
